var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPollLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.84619 10.3642V12.0002L2.67311 9.81892L4.84619 7.63625V9.27325C6.63876 9.27325 8.10546 7.80057 8.10546 6.00033C8.10546 5.45538 7.94289 4.90971 7.72566 4.4731L8.53993 3.65516C8.92045 4.36441 9.19168 5.12783 9.19168 6.00035C9.19166 8.4004 7.23652 10.3642 4.84619 10.3642ZM4.84619 2.72776C3.05292 2.72776 1.58692 4.20045 1.58692 6.00033C1.58692 6.54564 1.7495 7.0913 1.96673 7.52791L1.15246 8.3455C0.771939 7.63625 0.5 6.87317 0.5 6.00033C0.5 3.60026 2.45586 1.63679 4.84618 1.63679V0.000154495L7.01926 2.18175L4.84618 4.36443V2.72776H4.84619Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollLoading);
export default __webpack_public_path__ + "static/media/poll-loading.82d6f369859bfb239ab1cc52717807da.svg";
export { ForwardRef as ReactComponent };